import React from 'react';
import dollars from '../../dollar-format';
import {executeQuery} from "../../requests/executeQuery";
import {renderPrintFooter} from "../../utils";
import {HSC_PIPELINE} from "../../consts/queries";
import {columns} from "./columns";
import {HscPipelineModel} from "./hscPipelineModel";
import LinkComp from "../LinkComp/LinkComp";
import hscTeamMembers from '../../hsc-team-members';
import filter from '../../filter';
import Dropdown from '../Dropdown/Dropdown';
import { ApolloConsumer } from '@apollo/client';
import { Get_HSC_PIPELINE } from '../Graphql/Queries/HscPipelineQuery';
import { fetchData } from '../Service/graphQlService';


const limit = 50;
export default class HscPipeline extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rows: {},
            query:{},
            loading: false,
            isPrint: false,
            printBackground: '',
        };
		this.client = null;
        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    }

    fetch() {
        this.setState({loading: true});
        let query = {...this.state.query};
        const options = filter(query, 'hscPipeline');
		const token = localStorage.getItem('authToken');
        if(options.filter.where.length==0){
            options.filter.where=['CW1']
        }else  if(options.param.hsc_team_member_first=="NOMATCH" || options.param.hsc_team_member_last=="NOMATCH" ){
            options.filter.where=['CW1','CW2']
        }else if (typeof options.param.hsc_team_member_first === 'undefined' && typeof options.param.hsc_team_member_last === 'undefined') {
            options.param.hsc_team_member_first = 'mkeeler@athenacapitalre.com';
            options.param.hsc_team_member_last = 'gholley@highstcapital.com';
            //  options.param.hsc_team_member_last = 'jarnold@highstcapital.com';
            options.filter.where = ['CW1', 'CW2'];
        }
        
 // executeQuery({queryName: HSC_PIPELINE, options})
        function getTeamMemberVariables() {
            const data = query.HSC_TEAM_MEMBERS ? query.HSC_TEAM_MEMBERS.split(',') : [];
        
            // Extract first name and last name based on data array
            const firstName = data[0] || ""; // First element if available
            const lastName = data[1] || "";  // Second element if available
        
            // Construct the return object based on available values
            if (firstName && lastName) {
                return {
                    params: {
                        HSC_TEAM_MEMBER_FIRST: firstName,
                        HSC_TEAM_MEMBER_LAST: lastName,
                    },
                }
            } else if (firstName) {
                return {
                   params :{ HSC_TEAM_MEMBER_FIRST: firstName}
                };
            } else if (lastName) {
                return {
                    params :{ HSC_TEAM_MEMBER_LAST: lastName}
                };
            } else {
                return {};
            }
        }
        
        // Example options for query execution
        const queryoptions = getTeamMemberVariables();
        
            if (this.client) {
            // this.client.query({
            //     query: Get_HSC_PIPELINE, variables: queryoptions, fetchPolicy: "no-cache",
            //     // query: GET_AGENTS, variables:{pageOptions: pageParams},fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`, // Bearer token added here
            //         },
            //     },
            // })

           fetchData( Get_HSC_PIPELINE, queryoptions)
            .then(res => {
            if (res && res.data.hscPipeline.success && Array.isArray(res.data.hscPipeline.data)) {
                const rows = new HscPipelineModel(res.data.hscPipeline.data[0]);
                this.setState({rows, loading: false});
            }
        })
    } 
    
    }

    componentDidMount() {
           if (this.client && this.props.location && this.props.location.query) {
      this.fetch(this.props.location.query);
    }
        let query={
            HSC_TEAM_MEMBERS:''
        };
        hscTeamMembers.map((el, index)=>{
            query.HSC_TEAM_MEMBERS += el ? index === hscTeamMembers.length-1 ? el.EMAIL:el.EMAIL+',' : '';
        })
        this.setState({query, printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`}, this.fetch);
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
    }
     componentDidUpdate(prevProps) {
    if (
      this.client &&
      prevProps.location &&
      this.props.location &&
      prevProps.location.query !== this.props.location.query
    ) {
      this.fetch(this.props.location.query);
    }
  }
    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

    renderTable(columns, rows) {
        return (
            <table>
                <thead>
                <tr>
                    {
                        columns.map((column, index) => {
                            return <th key={index} className="Pipeline_th">{column.name}</th>
                        })
                    }
                </tr>
                </thead>
                <tbody>
                {
                    Object.keys(rows).map(key => {
                        return (
                            <tr key={key} className={`${key === 'closedTotal' && 'border-top'}`}>
                                {
                                    columns.map((column, index) => {
                                        let value = '';
                                        if (rows[key][column.key] !== null) {
                                            if (column.format === '$') {
                                                const withCents = column.withCents;
                                                value = dollars(rows[key][column.key], withCents);
                                            } else {
                                                value = rows[key][column.key];
                                            }
                                        }
                                        if (!rows[key].url && index === 0)
                                            return (
                                                <td
                                                    key={key + "-" + index}
                                                    className={`${column.class ? column.class : "Pipeline_td"} ${key === 'closedTotal' && 'Pipeline_th'}`}>
                                                    <LinkComp
                                                        to={`${arc.path.base}list?hsc_status=${rows[key].status}&source=HSC${this.state.query.HSC_TEAM_MEMBERS ? '&hsc_team_members='+this.state.query.HSC_TEAM_MEMBERS :''}`}>
                                                        {value}
                                                    </LinkComp>
                                                </td>
                                            );
                                        else if (rows[key].url && index === 0)
                                            return (
                                                <td key={key+'-'+index}
                                                    className={`${column.class ? column.class : "Pipeline_td"} ${key === 'closedTotal' && 'Pipeline_th'}`}>
                                                    <LinkComp to={`${arc.path.base}hsc-pipeline/${rows[key].url}${this.state.query.HSC_TEAM_MEMBERS ? '?HSC_TEAM_MEMBERS='+this.state.query.HSC_TEAM_MEMBERS :''}`}>
                                                        {value}
                                                    </LinkComp>
                                                </td>
                                            );
                                        return (
                                            <td key={key+'-'+index}
                                                className={`${column.class ? column.class : 'Pipeline_td'} ${key === 'closedTotal' && 'Pipeline_th'}`}>
                                                {value}
                                            </td>
                                        )
                                    })
                                }
                            </tr>
                        );
                    })
                }
                </tbody>
            </table>
        );
    }
    
    handleChangeDropdown(query, optionType, value, valueKey){
        query.HSC_TEAM_MEMBERS = query[valueKey];   
        this.setState({query}, this.fetch)
    }

    render() {
        const {rows, loading, isPrint, printBackground, query} = this.state;
        const d = new Date();
        const date = d.getMonth()+1+'/'+d.getDate()+'/'+d.getFullYear();

        return (
            <ApolloConsumer>
				{client => {
					 if (!this.client) {
            this.client = client;
          }
					return (
            <div className='Pipeline'>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    <div className='Pipeline_head'>
                        <div className="Pipeline_head_left">
                            <h3 className='Pipeline_h3'>AthCap Pipeline</h3>
                            <h4 className='Pipeline_h4'>{date}</h4>
                        </div>
                        <div className='Pipeline_head_right'>
                            <Dropdown
                                dropdownType='multiple'
                                optionsType='team-members'
                                optionLabelKey='NAME'
                                optionKey='EMAIL'
                                value={query.HSC_TEAM_MEMBERS}
                                label='Agent'
                                valueKey='HSC_TEAM_MEMBERS'
                                data={query}
                                handleParentChange={this.handleChangeDropdown}
                            />
                        </div>
                    </div>
                    {
                        loading ?
                            <div className='loading'>Loading data...</div>
                            :
                            this.renderTable(columns, rows)
                    }
                    {renderPrintFooter(isPrint, true)}
                </div>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
            </div>
            )
        }}

    </ApolloConsumer>
        );
    }
}
